import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject } from '@angular/core';
import { provideNgIconLoader, withCaching } from '@ng-icons/core';
import { catchError, of } from 'rxjs';

export const ICON_PROVIDERS = [
  provideNgIconLoader((name) => {
    const http = inject(HttpClient);
    const errorHandler = inject(ErrorHandler);
    // @ng-icons awaits the loader in a callback nobody handles, so a failed
    // request must never reach it as a rejection — not even when the
    // ErrorHandler rethrows, as jest-preset-angular's does. Report it, then
    // answer an empty SVG, which @ng-icons draws as nothing. Status 0 is the
    // visitor's connection (offline, aborted), not a file the deploy dropped,
    // so it is not reported.
    return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' }).pipe(
      catchError((error: unknown) => {
        const neverAnswered =
          error instanceof HttpErrorResponse && error.status === 0;
        if (!neverAnswered) {
          try {
            errorHandler.handleError(error);
          } catch {
            // The report was made; a rethrow here would only become the rejection.
          }
        }
        return of('');
      }),
    );
  }, withCaching()),
];
